import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";
import RolesContent from "./RolesContent";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import RolesContentMobile from "./RolesContentMobile";

export default function Roles() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <RolesContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={8} />
          <RolesContent />
        </>
      )}
    </div>
  );
}
